import { configureStore } from '@reduxjs/toolkit'
import calendarReducers from './calendarReducers'

export default configureStore({
  reducer: {
    calendar: calendarReducers
  }
})